import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

//styles
import { CustomBox } from './OutOfBandUpdatedDealBanner.style';

//libraries
import * as multiScenarioSelectors from '@makemydeal/dr-dash-store/selectors/multiScenarioSelectors';
import * as offerInfoSelectors from '@makemydeal/dr-dash-store/selectors/offerInfoSelectors';
import * as offerSelectors from '@makemydeal/dr-dash-store/selectors/offerSelectors';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as compositeSelectors from '@makemydeal/dr-dash-store/selectors/compositeSelectors';
import * as multiScenarioActionCreators from '@makemydeal/dr-dash-store/actions/multiScenarioActionCreators';
import { DARWIN_APPLICATION_NAME } from '@makemydeal/dr-dash-store/utils/darwinEventUtils';

//components
import { Alert } from '@interstate/components/Alert';
import { Action } from '@interstate/components/Action';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

const OutOfBandUpdatedDealBanner = () => {
    const dispatch = useDispatch();
    const moreRecentVersionAvailable = useSelector(multiScenarioSelectors.isMoreRecentVersionAvailable);
    const outOfBandBannerDisplayed = useSelector(multiScenarioSelectors.isOutOfBandBannerDisplayed);
    const updateDealBannerDisplayed = useSelector(offerInfoSelectors.getSocketEventNotification);
    const enableStaleDraftVersionDiscard = useSelector(featureToggleSelectors.enableStaleDraftVersionDiscard);
    // use case when draf discarded and latest version has comment
    const applicationName = useSelector(offerSelectors.getApplicationName);
    const offerComment = useSelector(offerReduxSelectors.getMessage);
    const isOfferCommentBannerEligible = useSelector(compositeSelectors.getIsOfferCommentBannerEligible);
    const isLogicalDraftRetentionEnabled = useSelector(featureToggleSelectors.isLogicalDraftRetentionEnabled);
    const isNonDarwinUpdate = isLogicalDraftRetentionEnabled && applicationName !== DARWIN_APPLICATION_NAME;
    useEffect(() => {
        if (moreRecentVersionAvailable && !isNonDarwinUpdate) {
            dispatch(multiScenarioActionCreators.outOfBandBannerDisplayed());
        }
    }, [moreRecentVersionAvailable, applicationName]);

    useEffect(() => {
        if (updateDealBannerDisplayed) {
            handleBanner();
        }
    }, [updateDealBannerDisplayed]);

    const handleBanner = () => {
        dispatch(multiScenarioActionCreators.outOfBandBannerHidden());
    };
    const showOfferComment = enableStaleDraftVersionDiscard && isOfferCommentBannerEligible;
    const sourceLabel = showOfferComment ? applicationName : 'another application';
    const alertInfo = () => (
        <div data-testid="banner-info-container">
            <span>
                {enableStaleDraftVersionDiscard
                    ? `A newer version of this deal was saved from ${sourceLabel}. Your draft changes could not be kept. The current version is now loaded.`
                    : 'Since this draft was created, new changes have been published for this offer.'}
            </span>
            {showOfferComment && <div>{offerComment}</div>}
        </div>
    );

    return (
        <>
            {outOfBandBannerDisplayed && !updateDealBannerDisplayed && (
                <CustomBox>
                    <Alert
                        data-testid="interstate-banner-container"
                        title={enableStaleDraftVersionDiscard ? 'Draft Discarded' : 'Updated Offer'}
                        type="caution"
                        displayCloseButton
                    >
                        {alertInfo()}
                        <div>
                            <Action data-testid="interstate-hide-banner-action" size="sm" onClick={handleBanner}>
                                Okay, Got It
                            </Action>
                        </div>
                    </Alert>
                </CustomBox>
            )}
        </>
    );
};

export default OutOfBandUpdatedDealBanner;
